module.exports = __webpack_public_path__ + "img/silhouette.fa6d2c28.jpg";